module.exports = __webpack_public_path__ + "static/img/p.d0b4b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p.png
// module id = A5Cd
// module chunks = 1